export default {
  state: {
    deferredPrompt: null
  },
  mutations: {
    storeDeferredPrompt (state, payload) {
      state.deferredPrompt = payload
      console.log('Mutation: paw/storeDeferredPrompt')
    }
  },
  actions: {
    listenForPrompt (context) {
      console.log('Mutation: paw/listenForPrompt')
      window.addEventListener('beforeinstallprompt', (e) => {
      // Prevent Chrome 67 and earlier from automatically showing the prompt
        e.preventDefault()
        // Stash the event so it can be triggered later.
        context.state.deferredPrompt = e
        console.log(e)
      })
    }
  },
  namespaced: true
}
